export enum ItemSizeSelector {
  Small,
  Medium,
  Large,
}
